<template>
  <v-card class="data-bgDataTable">
    <!-- cabecera del componente campo de busqqueda -->
    <v-card-title v-if="pIsSearch" class="data-buscadorDataTable px-4 pb-0">
      <v-text-field color="datPrimary" append-icon="search" v-model="search" :label="this.$t('buscar')"></v-text-field>
    </v-card-title>
    <!-- tabla -->
    <v-card-text class="pb-4 px-0">
      <v-data-table v-model="itemsChequeados" select-all v-bind:headers="headers" v-bind:items="items" :rows-per-page-items="rowsPerPageArray" :no-data-text="this.$t('noResultados')" :no-results-text="this.$t('noResultados')" v-bind:pagination.sync="pagination" :loading="loading" :total-items="totalItems" item-key="id" class="elevation-12 tableApplication tableLoading">
        <!-- cabecera tabla -->
        <template slot="headers" slot-scope="props">
          <tr class="data-gbGreyLight">
            <th id="checkAll" v-if="checkboxOn">
              <v-checkbox primary hide-details @change="chequeaTodo()" :input-value="props.all" :indeterminate="props.indeterminate"></v-checkbox>
            </th>
            <th class="text-xs-left" v-for="header in props.headers" :key="header.text" :id="header.value" :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '',  'text-xs-' + header.align ]" @click="cambiaOrden(header.value)">
              <v-icon>arrow_upward</v-icon>
              {{ header.text }}
            </th>
          </tr>
        </template>
        <!-- detalle tabla -->
        <template slot="items" slot-scope="props">
          <tr @click="seleccionaLinea(props)" :active="props.selected" :style="activeStyle(props)">
            <td v-if="checkboxOn" v-on:click.stop>
              <v-checkbox primary hide-details v-model="props.selected" :input-value="props.selected" @change="chequeaItem(props)"></v-checkbox>
            </td>
            <td class="text-xs-left" :class="alineaColumnas(index)" v-if="compruebaColumnasVisibles(index)" v-for="(item, index) in props.item" :key="index">{{item}}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>

export default {
  name: 'DataTable',
  props: {
    dataTableId: {
      type: String,
      required: false,
      default: 'tableID'
    },
    items: {
      type: Array,
      required: true
    },
    totalItems: {
      type: Number,
      required: true
    },
    rowsPerPage: {
      type: Number,
      required: false,
      default: 5
    },
    descending: {
      type: Boolean,
      required: false,
      default: false
    },
    sortBy: {
      type: String,
      required: false,
      default: '1'
    },
    loading: {
      type: Boolean,
      required: false
    },
    headers: {
      type: Array,
      required: true
    },
    checkboxOn: {
      type: Boolean,
      required: false,
      default: false
    },
    getDataApi: {
      type: String,
      required: false,
      default: ''
    },
    clickedApi: {
      type: String,
      required: false
    },
    selectedApi: {
      type: String,
      required: false
    },
    filterApi: {
      type: String,
      required: false
    },
    initSearch: {
      type: String,
      required: false,
      default: ''
    },
    markSelected: {
      type: Boolean,
      required: false,
      default: false
    },
    isVisible: {
      type: Boolean,
      required: false,
      default: true
    },
    pIsSearch: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      search: '',
      timerSearch: null,
      pagination: {'sortBy': this.sortBy, 'descending': this.descending, 'rowsPerPage': this.rowsPerPage},
      itemsChequeados: [],
      filters: [],
      selectedItem: {},
      rowsPerPageArray: [this.rowsPerPage],
      cargaInicialBusqueda: false
    }
  },
  watch: {
    search: {
      handler () {
        if (!this.cargaInicialBusqueda) {
          clearInterval(this.timerSearch)
          this.timerSearch = setTimeout(function () {
            this.cargaDatosConApi('search')
          }.bind(this), 500)
        } else {
          this.cargaInicialBusqueda = false
        }
      }
    },
    initSearch: {
      handler () {
        this.cargaInicialBusqueda = true
        this.search = this.initSearch
      }
    },
    pagination: {
      handler () {
        if (this.isVisible) {
          this.cargaDatosConApi('pagination')
        }
      },
      deep: true
    },
    'items' (items) {
      this.selectedItem = items[0]
    }
  },
  created () {
    /*
     * evento de filtrado
     */
    this.$bus.$on(this.filterApi, (filters) => {
      this.filters = filters
      this.cargaDatosConApi('search')
    })
  },
  beforeDestroy () {
    /*
     * evento de filtrado
     */
    this.$bus.$off(this.filterApi)
  },
  methods: {
    /*
     * Comprueba si una priopiedad existe en la cabecera para ver si la muestra o no
     */
    compruebaColumnasVisibles (index) {
      for (let i = 0; i < this.headers.length; i++) {
        const header = this.headers[i]
        if (header.value === index) {
          return true
        }
      }
      return false
    },
    /*
     * alinea las columnas
     */
    alineaColumnas (index) {
      for (let i = 0; i < this.headers.length; i++) {
        const header = this.headers[i]
        if (header.value === index) {
          return 'text-xs-' + header.align
        }
      }
      return 'text-xs-left'
    },
    /*
     * chequea un solo item
     */
    chequeaItem (props) {
      props.selected = !props.selected
      if (!props.selected) {
        this.itemsChequeados.push(props.item)
      } else {
        const index = this.itemsChequeados.indexOf(props.item)
        if (index > -1) {
          this.itemsChequeados.splice(index, 1)
        }
      }
      if (this.selectedApi !== undefined && this.selectedApi !== '') {
        this.$bus.$emit(this.selectedApi, this.itemsChequeados)
      }
      this.$emit('select', this.itemsChequeados)
    },
    /*
     * chequea todos los items
     */
    chequeaTodo () {
      if (this.itemsChequeados.length) {
        this.itemsChequeados = []
      } else {
        this.itemsChequeados = this.items.slice()
      }
      if (this.selectedApi !== undefined && this.selectedApi !== '') {
        this.$bus.$emit(this.selectedApi, this.itemsChequeados)
      }
      this.$emit('selectAll', this.itemsChequeados)
    },
    /*
     * cambia el orden de an columna
     */
    cambiaOrden (column) {
      this.pagination.page = 1
      this.pagination.rowsPerPage = this.rowsPerPage
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    },
    /*
     * selecciona una linea
     */
    seleccionaLinea (props) {
      this.selectedItem = props.item
      if ((this.clickedApi !== undefined) && (this.clickedApi !== null)) {
        this.$bus.$emit(this.clickedApi, props.item)
      }
      this.$emit('click', props.item)
    },
    /*
     * selecciona una linea
     */
    activeStyle (props) {
      if (this.selectedItem === props.item) {
        return 'background:#EEE'
      } else {
        return ''
      }
    },
    /*
     * carga datos con el api
     */
    cargaDatosConApi (operacion) {
      // si es uan busqueda resetea la paginacion

      if (operacion === 'search') {
        this.pagination.page = 1
        this.pagination.rowsPerPage = this.rowsPerPage
      }
      const { sortBy, descending, page, rowsPerPage } = this.pagination
      // llama a la carga de datos
      if (this.getDataApi !== '') {
        this.$bus.$emit(this.getDataApi, { sortBy: sortBy, descending: descending, page: page, rowsPerPage: rowsPerPage, search: this.search, filters: this.filters })
      }
      this.$emit('recharge', { sortBy: sortBy, descending: descending, page: page, rowsPerPage: rowsPerPage, search: this.search, filters: this.filters })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components_datadec/DataTable.vue